/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetZonePostalCodeByPostalCodeDto } from '../models/custom-result-of-get-zone-postal-code-by-postal-code-dto';
import { CustomResultOfListOfGetZonePostalCodesForSendDto } from '../models/custom-result-of-list-of-get-zone-postal-codes-for-send-dto';
import { CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-zone-postal-codes-with-pagination-dto';
import { zonePostalCodesCreateGet } from '../fn/zone-postal-codes/zone-postal-codes-create-get';
import { ZonePostalCodesCreateGet$Params } from '../fn/zone-postal-codes/zone-postal-codes-create-get';
import { zonePostalCodesCreatePost } from '../fn/zone-postal-codes/zone-postal-codes-create-post';
import { ZonePostalCodesCreatePost$Params } from '../fn/zone-postal-codes/zone-postal-codes-create-post';
import { zonePostalCodesDeleteDelete } from '../fn/zone-postal-codes/zone-postal-codes-delete-delete';
import { ZonePostalCodesDeleteDelete$Params } from '../fn/zone-postal-codes/zone-postal-codes-delete-delete';
import { zonePostalCodesDeleteGet } from '../fn/zone-postal-codes/zone-postal-codes-delete-get';
import { ZonePostalCodesDeleteGet$Params } from '../fn/zone-postal-codes/zone-postal-codes-delete-get';
import { zonePostalCodesGetWithPagination } from '../fn/zone-postal-codes/zone-postal-codes-get-with-pagination';
import { ZonePostalCodesGetWithPagination$Params } from '../fn/zone-postal-codes/zone-postal-codes-get-with-pagination';
import { zonePostalCodesGetZonePostalCodesAuditWithPagination } from '../fn/zone-postal-codes/zone-postal-codes-get-zone-postal-codes-audit-with-pagination';
import { ZonePostalCodesGetZonePostalCodesAuditWithPagination$Params } from '../fn/zone-postal-codes/zone-postal-codes-get-zone-postal-codes-audit-with-pagination';
import { zonePostalCodesGetZonePostalCodesForSend } from '../fn/zone-postal-codes/zone-postal-codes-get-zone-postal-codes-for-send';
import { ZonePostalCodesGetZonePostalCodesForSend$Params } from '../fn/zone-postal-codes/zone-postal-codes-get-zone-postal-codes-for-send';
import { zonePostalCodesUpdateGet } from '../fn/zone-postal-codes/zone-postal-codes-update-get';
import { ZonePostalCodesUpdateGet$Params } from '../fn/zone-postal-codes/zone-postal-codes-update-get';
import { zonePostalCodesUpdatePut } from '../fn/zone-postal-codes/zone-postal-codes-update-put';
import { ZonePostalCodesUpdatePut$Params } from '../fn/zone-postal-codes/zone-postal-codes-update-put';

@Injectable({ providedIn: 'root' })
export class ZonePostalCodesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `zonePostalCodesCreateGet()` */
  static readonly ZonePostalCodesCreateGetPath = '/ZonePostalCodes/Create';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesCreateGet$Response(params?: ZonePostalCodesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return zonePostalCodesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesCreateGet(params?: ZonePostalCodesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.zonePostalCodesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesCreatePost()` */
  static readonly ZonePostalCodesCreatePostPath = '/ZonePostalCodes/Create';

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesCreatePost$Response(params: ZonePostalCodesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonePostalCodesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesCreatePost(params: ZonePostalCodesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonePostalCodesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesUpdateGet()` */
  static readonly ZonePostalCodesUpdateGetPath = '/ZonePostalCodes/Update';

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesUpdateGet$Response(params?: ZonePostalCodesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetZonePostalCodeByPostalCodeDto>> {
    return zonePostalCodesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesUpdateGet(params?: ZonePostalCodesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetZonePostalCodeByPostalCodeDto> {
    return this.zonePostalCodesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetZonePostalCodeByPostalCodeDto>): CustomResultOfGetZonePostalCodeByPostalCodeDto => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesUpdatePut()` */
  static readonly ZonePostalCodesUpdatePutPath = '/ZonePostalCodes/Update';

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesUpdatePut$Response(params: ZonePostalCodesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonePostalCodesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesUpdatePut(params: ZonePostalCodesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonePostalCodesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesDeleteGet()` */
  static readonly ZonePostalCodesDeleteGetPath = '/ZonePostalCodes/Delete';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesDeleteGet$Response(params?: ZonePostalCodesDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return zonePostalCodesDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonePostalCodesDeleteGet(params?: ZonePostalCodesDeleteGet$Params, context?: HttpContext): Observable<Blob> {
    return this.zonePostalCodesDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesDeleteDelete()` */
  static readonly ZonePostalCodesDeleteDeletePath = '/ZonePostalCodes/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesDeleteDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesDeleteDelete$Response(params: ZonePostalCodesDeleteDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonePostalCodesDeleteDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesDeleteDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesDeleteDelete(params: ZonePostalCodesDeleteDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonePostalCodesDeleteDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesGetWithPagination()` */
  static readonly ZonePostalCodesGetWithPaginationPath = '/ZonePostalCodes/GetWithPagination';

  /**
   * دریافت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesGetWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetWithPagination$Response(params: ZonePostalCodesGetWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto>> {
    return zonePostalCodesGetWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesGetWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetWithPagination(params: ZonePostalCodesGetWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto> {
    return this.zonePostalCodesGetWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto>): CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesGetZonePostalCodesAuditWithPagination()` */
  static readonly ZonePostalCodesGetZonePostalCodesAuditWithPaginationPath = '/ZonePostalCodes/GetZonePostalCodesAuditWithPagination';

  /**
   * دریافت لاگ بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesGetZonePostalCodesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetZonePostalCodesAuditWithPagination$Response(params: ZonePostalCodesGetZonePostalCodesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return zonePostalCodesGetZonePostalCodesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لاگ بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesGetZonePostalCodesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetZonePostalCodesAuditWithPagination(params: ZonePostalCodesGetZonePostalCodesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.zonePostalCodesGetZonePostalCodesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `zonePostalCodesGetZonePostalCodesForSend()` */
  static readonly ZonePostalCodesGetZonePostalCodesForSendPath = '/ZonePostalCodes/GetZonePostalCodesForSend';

  /**
   * دریاف برای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonePostalCodesGetZonePostalCodesForSend()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetZonePostalCodesForSend$Response(params: ZonePostalCodesGetZonePostalCodesForSend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetZonePostalCodesForSendDto>> {
    return zonePostalCodesGetZonePostalCodesForSend(this.http, this.rootUrl, params, context);
  }

  /**
   * دریاف برای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonePostalCodesGetZonePostalCodesForSend$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonePostalCodesGetZonePostalCodesForSend(params: ZonePostalCodesGetZonePostalCodesForSend$Params, context?: HttpContext): Observable<CustomResultOfListOfGetZonePostalCodesForSendDto> {
    return this.zonePostalCodesGetZonePostalCodesForSend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetZonePostalCodesForSendDto>): CustomResultOfListOfGetZonePostalCodesForSendDto => r.body)
    );
  }

}
